import Model from './BaseModel'
import State from './State'

export default class City extends Model {
    resourceName() {
        return 'cities'
    }

    fields() {
        return ['id', 'name', 'ibge_code', 'state_id']
    }

    relationships() {
        return {
            state: new State(),
        }
    }
}
